// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "developerStaticHighlighter" + ".817ca363e.chunk.js"
}